// Single source of truth for "who is this user" across the app.
// Persona (archetype) determines the experience; institution customizes it;
// career target personalizes it. Every Opportunities surface consumes this.

const STATE_ABBR = {
  'new jersey': 'NJ', 'new york': 'NY', 'pennsylvania': 'PA', 'california': 'CA',
  'texas': 'TX', 'florida': 'FL', 'massachusetts': 'MA', 'north carolina': 'NC',
};

const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : '');

export function resolveUserContext(user) {
  if (!user) {
    return { archetype: 'UNKNOWN', isCollege: false, isHS: false, isAdult: false,
      educationLevel: '', academicYear: '', major: '', institution: '',
      careerTarget: '', stateCode: '' };
  }
  const isCollege = user.student_type === 'college'
    || user.welcome_archetype === 'college_student'
    || (!!user.major && !user.grade_level);
  const isHS = !isCollege && (
    !!user.grade_level
    || user.education_level === 'high_school'
    || user.learning_stage === 'high_school'
    || user.welcome_archetype === 'high_school_student'
  );
  const isAdult = !isCollege && !isHS;
  const archetype = isCollege ? 'COLLEGE_STUDENT' : isHS ? 'HIGH_SCHOOL_STUDENT' : 'ADULT_LEARNER';

  const yr = (user.academic_year || '').toString();
  const educationLevel = isCollege
    ? (yr ? `Undergraduate — ${cap(yr)}` : 'College Student')
    : isHS ? 'High School Student' : 'Adult Learner';
  // Value that matches the Internships filter option set.
  const internshipEducationLevel = isCollege ? 'Four-Year College Student'
    : isHS ? 'High School Student' : 'Adult Learner';

  const rawState = (user.state || '').toString();
  const stateCode = rawState.length === 2 ? rawState.toUpperCase()
    : STATE_ABBR[rawState.toLowerCase()] || '';

  return {
    archetype, isCollege, isHS, isAdult,
    educationLevel, internshipEducationLevel,
    academicYear: yr,
    major: user.major || '',
    minor: user.minor || '',
    institution: user.institution || user.organization_name || '',
    careerTarget: user.career_target || user.career_aspirations || '',
    stateCode,
  };
}
